import { useSelector, useDispatch } from "react-redux";
import Condition from "./Condition";
import React, { useState, useEffect, useRef } from "react";
import { RadioButton, Input } from "@progress/kendo-react-inputs";
import { addCondition, addSubclause, updateLogicOperator } from "../../redux/querySlice";

export const Clause = ({ query, dataSource, dropDownArray, index, filteredData }) => {
    const dispatch = useDispatch();
    const changeLogicOperator = (e) => {
        const newOperator = e.value;
        dispatch(updateLogicOperator([newOperator, ...index]));
    };

    const handleAddCondition = () => {
        const condition = createCondition(dropDownArray, stringOperators);
        dispatch(addCondition([condition, ...index]));
    };

    const handleAddSubclause = () => {
        const subClause = createSubClause(dropDownArray, stringOperators);
        dispatch(addSubclause([subClause, ...index]));
    };
    return (
        <div className={`clause-select ${index.length > 1 ? "subclause" : ""}`}>
            {index.length === 1 && <div>Find results in {`${dataSource}`} where:</div>}
            <div className="clause-buttons">
                <div className="clause-button">
                    <RadioButton
                        value="AND"
                        checked={query.logicOperator === "AND"}
                        onChange={changeLogicOperator}
                        style={{ marginLeft: "8px", marginRight: "8px" }}
                    />
                    AND - All of the following must be true
                </div>
                <div className="clause-button">
                    <RadioButton
                        value="OR"
                        checked={query.logicOperator === "OR"}
                        onChange={changeLogicOperator}
                        style={{ marginLeft: "8px", marginRight: "8px" }}
                    />
                    OR - Any of the following must be true
                </div>
            </div>
            {query.conditions.map((condition, i) => {
                // If item is subclause
                if (condition.logicOperator !== undefined) {
                    return (
                        <div key={i}>
                            {" "}
                            {i > 0 && (
                                <div className="logic-operator">
                                    {query.logicOperator}
                                </div>
                            )}
                            <Clause
                                dropDownArray={dropDownArray}
                                query={condition}
                                index={[...index, i]}
                            />
                        </div>
                    );
                }
                // If item is condition
                else {
                    return (
                        <div key={i}>
                            {i > 0 && (
                                <div className="logic-operator">
                                    {query.logicOperator}{" "}
                                </div>
                            )}
                            <Condition
                                dropDownArray={dropDownArray}
                                query={query}
                                index={[...index, i]}
                                filteredData={filteredData}
                            />
                        </div>
                    );
                }
            })}
            <div className="query-add-ons">
                <div onClick={handleAddCondition} className="query-add-on">
                    + Add Condition
                </div>
                {/* {index.length === 1 && ( */}
                <div onClick={handleAddSubclause} className="query-add-on">
                    + Add Subclause
                </div>
                {/* )} */}
            </div>
        </div>
    );
};

export default Clause;

const createCondition = (dropDownData, comparisonOperator, domainValue) => {
    const value = domainValue ?? "";
    const condition = {
        field: dropDownData[0],
        operator: comparisonOperator[0],
        value: value,
    };
    return condition;
};

const createSubClause = (dropDownArray, comparisonOperator) => {
    const subClause = {
        logicOperator: "AND",
        conditions: [
            createCondition(dropDownArray, comparisonOperator),
            createCondition(dropDownArray, comparisonOperator),
        ],
    };
    return subClause;
};

const stringOperators = [
    "=",
    "!=",
    "contains",
    "does not contain",
    "starts with",
    "ends with",
];
